import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { MinimumWageConfigurationModel } from '@/app/models/configuration/minimumWageConfigurationModel';
import { SETTINGS_QUERY_ALWAYS_REVALIDATE } from '@/lib/api/constants'

/**
 * Fetches basic company settings.
 */
export function useMinimumWageQuery(companyId: string) {
  return useQuery<MinimumWageConfigurationModel>({
    queryKey: ['configuration.minimumWage', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/api/${companyId}/configuration/minimumWage`);
      return data;
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_ALWAYS_REVALIDATE,
  });
}
